document.addEventListener('DOMContentLoaded', () => {
  // =========================================================
  // 1. CONFIGURATION
  // =========================================================
  // Replace this URL with your own living room image from Content > Files anytime!
  const DEFAULT_ROOM_IMAGE = 'https://cdn.shopify.com/s/files/1/0278/2619/2473/files/room-warm-living-room-wall-setup_678e0c53-4771-4fbc-ad60-4ec094a43f02.png?v=1792870926';

  const roomCanvas = document.getElementById('roomCanvas'),
        ctx = roomCanvas.getContext('2d');
  const clockOverlay = document.getElementById('clockOverlay'),
        canvasContainer = document.getElementById('canvasContainer');
  const scaleSlider = document.getElementById('scaleSlider'),
        scaleVal = document.getElementById('scaleVal');
  const rotateSlider = document.getElementById('rotateSlider'),
        rotateVal = document.getElementById('rotateVal');
  const keystoneSlider = document.getElementById('keystoneSlider'),
        keystoneVal = document.getElementById('keystoneVal');
  const galleryBtn = document.getElementById('gallerySelectBtn'),
        galleryDropdown = document.getElementById('galleryDropdown'),
        galleryStatus = document.getElementById('galleryStatus');
  const roomUpload = document.getElementById('roomUpload'),
        roomUploadBtn = document.getElementById('roomUploadBtn');
  const rpLocal = document.getElementById('rp-local'),
        rpLocalChange = document.getElementById('rp-local-change'),
        rpLocalRemove = document.getElementById('rp-local-remove');

  // ===== Scale prefs
  const DEFAULT_SCALE_3 = 100,
        DEFAULT_SCALE_5 = 150;
  const KEY_LAST_CLASS = "lcw-last-class",
        KEY_SCALE_3 = "lcw-scale-3",
        KEY_SCALE_5 = "lcw-scale-5";

  function getInitialScale(isFive) {
    const def = isFive ? DEFAULT_SCALE_5 : DEFAULT_SCALE_3;
    const key = isFive ? KEY_SCALE_5 : KEY_SCALE_3;
    let v = sessionStorage.getItem(key);
    return v ? Number(v) : def;
  }
  function persistScale(isFive) {
    sessionStorage.setItem(isFive ? KEY_SCALE_5 : KEY_SCALE_3, scaleSlider.value);
    sessionStorage.setItem(KEY_LAST_CLASS, isFive ? "5" : "3");
  }

  // ===== State
  let galleryProducts = [],
      roomBitmap = null,
      roomW = 0,
      roomH = 0;
  let lastOverlayX = null,
      lastOverlayY = null,
      lastRotation = 0,
      lastKeystone = 0,
      lastScale = 1.0;

  // ===== IndexedDB helpers
  function readSavedBlob() {
    return new Promise((resolve, reject) => {
      const req = indexedDB.open('lcw-roomphoto', 1);
      req.onupgradeneeded = () => req.result.createObjectStore('photos');
      req.onsuccess = () => {
        const db = req.result,
              tx = db.transaction('photos', 'readonly'),
              g = tx.objectStore('photos').get('current');
        g.onsuccess = () => resolve(g.result || null);
        g.onerror = () => reject(g.error);
      };
      req.onerror = () => reject(req.error);
    });
  }

  // ===== Canvas Drawing
  function sizeAndDraw() {
    if (!roomBitmap) return;
    const dispW = canvasContainer.clientWidth || 800;
    const dispH = Math.round(dispW * (roomH / roomW));
    roomCanvas.style.width = dispW + 'px';
    roomCanvas.style.height = dispH + 'px';
    roomCanvas.width = dispW;
    roomCanvas.height = dispH;
    ctx.clearRect(0, 0, dispW, dispH);
    ctx.drawImage(roomBitmap, 0, 0, dispW, dispH);
    canvasContainer.style.height = dispH + 'px';

    // Position clock in center-upper third on first load
    if (lastOverlayX === null || lastOverlayY === null) {
      lastOverlayX = Math.round((dispW - 400) / 2);
      lastOverlayY = Math.round(dispH * 0.28);
      clockOverlay.style.left = lastOverlayX + 'px';
      clockOverlay.style.top = lastOverlayY + 'px';
    }
  }

  async function drawFromBlob(blob) {
    roomBitmap = await createImageBitmap(blob);
    roomW = roomBitmap.width;
    roomH = roomBitmap.height;
    sizeAndDraw();
  }

  // Load an image from an external URL (Sample Room)
  function loadRoomFromUrl(url) {
    const img = new Image();
    img.crossOrigin = 'anonymous';
    img.onload = async () => {
      try {
        roomBitmap = await createImageBitmap(img);
      } catch (err) {
        roomBitmap = img; // Fallback if createImageBitmap is restricted
      }
      roomW = img.naturalWidth || img.width;
      roomH = img.naturalHeight || img.height;
      sizeAndDraw();
    };
    img.src = url;
  }

  // ===== Upload & Local Storage
  async function setRoomImageFromFile(file) {
    const img = new Image();
    img.onload = () => {
      const M = 2000,
            w = Math.round(img.width * Math.min(1, M / Math.max(img.width, img.height))),
            h = Math.round(img.height * Math.min(1, M / Math.max(img.width, img.height)));
      const c = document.createElement('canvas');
      c.width = w;
      c.height = h;
      c.getContext('2d').drawImage(img, 0, 0, w, h);
      c.toBlob(async b => {
        if (b) {
          try {
            await window.RoomPhoto?.setPhotoFromFile?.(new File([b], 'room.jpg', { type: 'image/jpeg' }));
          } catch(e) {}
          await drawFromBlob(b);
          refreshLocalBadge();
        }
      }, 'image/jpeg', 0.85);
    };
    img.src = URL.createObjectURL(file);
  }

  async function loadInitialRoom() {
    let hasCustom = false;
    try {
      if (window.RoomPhoto?.hasPhoto && await RoomPhoto.hasPhoto()) {
        const blob = await readSavedBlob();
        if (blob) {
          await drawFromBlob(blob);
          hasCustom = true;
        }
      }
    } catch (e) {}

    // If no custom user photo, load default room photo
    if (!hasCustom) {
      loadRoomFromUrl(DEFAULT_ROOM_IMAGE);
    }
    refreshLocalBadge();
  }

  async function refreshLocalBadge() {
    try {
      const hasCustom = window.RoomPhoto?.hasPhoto && await RoomPhoto.hasPhoto();
      if (rpLocal) rpLocal.hidden = !hasCustom;
      if (roomUploadBtn) {
        roomUploadBtn.textContent = hasCustom ? "Upload a different room photo" : "Upload a photo of your room";
      }
    } catch {
      if (rpLocal) rpLocal.hidden = true;
    }
  }

  if (roomUploadBtn) roomUploadBtn.addEventListener('click', () => roomUpload.click());
  if (roomUpload) roomUpload.addEventListener('change', e => { if (e.target.files[0]) setRoomImageFromFile(e.target.files[0]); });
  if (rpLocalChange) rpLocalChange.addEventListener('click', e => { e.preventDefault(); roomUpload.click(); });
  if (rpLocalRemove) {
    rpLocalRemove.addEventListener('click', async e => {
      e.preventDefault();
      try { await window.RoomPhoto?.removePhoto?.(); } catch {}
      // Fallback back to sample room
      loadRoomFromUrl(DEFAULT_ROOM_IMAGE);
      refreshLocalBadge();
    });
  }

  // ===== Window Resize
  window.addEventListener('resize', () => {
    if (roomBitmap) sizeAndDraw();
    applyTransform();
  });

  // ===== Dragging
  let dragging = false, sx = 0, sy = 0, sl = 0, st = 0;
  clockOverlay.addEventListener('dragstart', e => e.preventDefault());
  clockOverlay.addEventListener('pointerdown', e => {
    if (e.button !== 0) return;
    dragging = true;
    clockOverlay.classList.add('dragging');
    sx = e.clientX; sy = e.clientY;
    const cs = getComputedStyle(clockOverlay);
    sl = parseFloat(cs.left) || 0; st = parseFloat(cs.top) || 0;
    clockOverlay.setPointerCapture?.(e.pointerId);
  });
  clockOverlay.addEventListener('pointermove', e => {
    if (!dragging) return;
    clockOverlay.style.left = (sl + e.clientX - sx) + 'px';
    clockOverlay.style.top = (st + e.clientY - sy) + 'px';
    lastOverlayX = sl + e.clientX - sx;
    lastOverlayY = st + e.clientY - sy;
  });
  function stopDragging() {
    dragging = false;
    clockOverlay.classList.remove('dragging');
  }
  clockOverlay.addEventListener('pointerup', stopDragging);
  clockOverlay.addEventListener('pointercancel', stopDragging);

  // ===== Sliders & Transform
  function applyTransform() {
    const s = Number(scaleSlider.value) / 100,
          r = Number(rotateSlider.value),
          k = keystoneSlider ? Number(keystoneSlider.value) : 0;

    scaleVal.textContent = scaleSlider.value + '%';
    rotateVal.textContent = rotateSlider.value + '°';
    if (keystoneVal) keystoneVal.textContent = k + '°';

    clockOverlay.style.transform = `
      perspective(1000px)
      rotateY(${k}deg)
      rotate(${r}deg)
      scale(${s})
    `;
    clockOverlay.style.transformOrigin = 'center center';

    lastRotation = r;
    lastKeystone = k;
    lastScale = s;
  }

  scaleSlider.addEventListener('input', () => {
    applyTransform();
    const cls = sessionStorage.getItem(KEY_LAST_CLASS) || "3";
    persistScale(cls === "5");
  });
  rotateSlider.addEventListener('input', applyTransform);
  if (keystoneSlider) keystoneSlider.addEventListener('input', applyTransform);

  // ===== Overlay Clock Display
  function setClockSrc(src, isFive = false) {
    clockOverlay.src = src;
    clockOverlay.style.display = 'block';

    if (lastOverlayX !== null && lastOverlayY !== null) {
      clockOverlay.style.left = lastOverlayX + 'px';
      clockOverlay.style.top = lastOverlayY + 'px';
    }

    rotateSlider.value = lastRotation;
    if (keystoneSlider) keystoneSlider.value = lastKeystone;
    scaleSlider.value = Math.round(lastScale * 100);

    applyTransform();
    sessionStorage.setItem(KEY_LAST_CLASS, isFive ? "5" : "3");
  }

  // Load a product into the viewer by its handle
  async function loadProductByHandle(handle) {
    try {
      const res = await fetch(`/products/${handle}.json`);
      const data = await res.json(),
            product = data?.product,
            imgs = product?.images || [];
      if (imgs[1]?.src && /\.png(\?|$)/i.test(imgs[1].src)) {
        const src = imgs[1].src.replace(/^http:\/\//, 'https://') + '?width=1600';
        const isFive = /5(?:-|\s)?(?:foot|ft)|60\s*inch/i.test(product.title || "");
        if (galleryBtn) galleryBtn.textContent = product.title || handle;
        setClockSrc(src, isFive);
      }
    } catch(err) {
      console.error("Failed to load product", handle, err);
    }
  }

  // ===== Gallery Loading
  function hasPngSecondImage(p) {
    const url = p?.images?.[1]?.src || "";
    return /\.png(\?|$)/i.test(url);
  }
  function isEligibleProduct(p) {
    return !!(p && hasPngSecondImage(p));
  }

  function populateDropdown(products) {
    galleryDropdown.innerHTML = products.map(p => {
      const thumb = p.images?.[1]?.src ? p.images[1].src + '?width=120' : '';
      return `
        <div class="gallery-item" data-handle="${p.handle}">
          <img src="${thumb}" alt="" class="gallery-thumb">
          <span class="gallery-title">${p.title}</span>
        </div>
      `;
    }).join('');
  }

  async function fetchGallery() {
    try {
      const res = await fetch('/collections/archives/products.json?limit=250');
      const data = await res.json();
      galleryProducts = (data?.products || []).filter(isEligibleProduct);
      populateDropdown(galleryProducts);

      const queryHandle = new URLSearchParams(location.search).get('product');
      if (queryHandle) {
        loadProductByHandle(queryHandle);
      } else if (galleryProducts.length > 0) {
        // Look for Glinda by title or handle; fallback to first clock if not found
        const glinda = galleryProducts.find(p => 
          /glinda/i.test(p.title) || /glinda/i.test(p.handle)
        );
        const defaultHandle = glinda ? glinda.handle : galleryProducts[0].handle;
        loadProductByHandle(defaultHandle);
      }
    } catch(err) {
      console.error("Gallery fetch failed", err);
    }
  }
  
  // Dropdown toggle & selection
  galleryBtn.addEventListener('click', () => {
    galleryDropdown.classList.toggle('hidden');
  });

  galleryDropdown.addEventListener('click', e => {
    const item = e.target.closest('.gallery-item');
    if (!item) return;
    const handle = item.dataset.handle;
    galleryDropdown.classList.add('hidden');
    loadProductByHandle(handle);
  });

  document.addEventListener('click', e => {
    const isInside = e.target.closest('#gallerySelectWrapper');
    if (!isInside) galleryDropdown.classList.add('hidden');
  });

  function setVhVar() {
    document.documentElement.style.setProperty('--vh', `${window.innerHeight / 100}px`);
  }
  window.addEventListener('resize', setVhVar);
  window.addEventListener('orientationchange', setVhVar);
  setVhVar();

  // ===== Initialization
  loadInitialRoom();
  fetchGallery();
});